import MicroModal from 'micromodal';

export default function modal () {

    const bodyCssClass = 'modal-open';

    const Selector = {
        MODAL_OPEN: '[data-modal-trigger]',
        MODAL_CONTAINER: '.js-modal',
    }

    const element = {
        MODAL_OPEN: document.querySelectorAll(Selector.MODAL_OPEN),
        MODAL_CONTAINER: document.querySelectorAll(Selector.MODAL_CONTAINER),
    }

    function init () {
        if(element.MODAL_CONTAINER) {
            window.classicModal = {
                init: MicroModal.init({
                    onShow: modal => onShowActions(modal),
                    onClose: modal => onCloseActions(modal),
                    openTrigger: 'data-modal-trigger',
                }),
                show: MicroModal.show,
                close: MicroModal.close,
            };
            element.MODAL_CONTAINER.forEach(container => {
                const modalId = container.getAttribute('id');

                document.addEventListener('click', (e) => {
                    if (!e.target.closest(Selector.MODAL_OPEN) && !e.target.closest('#'+ modalId)) {
                        //window.classicModal.close(modalId);
                    }
                });
            });
        }
    }

    function onCloseActions (modal) {
        modal.setAttribute("inert", true);
        document.body.classList.remove(bodyCssClass);
    }

    function onShowActions (modal) {
        modal.removeAttribute("inert");
        modal.querySelector("[data-micromodal-close]").focus();
        document.body.classList.add(bodyCssClass);
    }

    init();
}